function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnboardingGroup = void 0;
Object.defineProperty(exports, "OnboardingGroupController", {
  enumerable: true,
  get: function get() {
    return _OnboardingGroupController.OnboardingGroupController;
  }
});
exports.OnboardingGroupPages = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _components = require("../../components");
var _OnboardingGroupController = require("./OnboardingGroupController");
var _native = require("@react-navigation/native");
var _nativeStack = require("@react-navigation/native-stack");
var Pages = _interopRequireWildcard(require("./OnboardingGroupPages"));
var _styles = require("../../styles");
var _reactNative = require("react-native-web");
var _utils = require("../../utils");
var _Context = require("./Context");
var _PagePathnames = require("./OnboardingGroupPages/PagePathnames");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["isLoading", "person"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var OnboardingGroupPages = exports.OnboardingGroupPages = Object.keys(Pages).reduce(function (a, v) {
  return Object.assign({}, a, (0, _defineProperty2["default"])({}, v, v));
}, {});
var Stack = (0, _nativeStack.createNativeStackNavigator)();
var OnboardingGroup = exports.OnboardingGroup = (0, _react.memo)(function (_ref) {
  var _ref$controller = _ref.controller,
    controller = _ref$controller === void 0 ? new _OnboardingGroupController.OnboardingGroupController() : _ref$controller;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  var _controller$useContro = controller.useController(),
    isLoading = _controller$useContro.isLoading,
    person = _controller$useContro.person,
    extraControllerProps = (0, _objectWithoutProperties2["default"])(_controller$useContro, _excluded);
  var _routeRef = (0, _react.useRef)();
  var _navigationRef = (0, _native.useNavigationContainerRef)();
  var _useAnalytics = (0, _utils.useAnalytics)(),
    trackEvent = _useAnalytics.trackEvent,
    trackingEvents = _useAnalytics.trackingEvents,
    getTrackingURL = _useAnalytics.getTrackingURL;
  var _trackScreen = function _trackScreen(currentRoute) {
    if (!currentRoute) return;
    var _pathname = _PagePathnames.PagePathnames[currentRoute];
    if (!_pathname) return;
    var _url = getTrackingURL(_pathname);
    trackEvent({
      eventName: trackingEvents.pageview,
      url: _url
    });
    trackEvent({
      eventName: trackingEvents.screenview,
      url: _url
    });
  };
  var _onReady = function _onReady() {
    var _navigationRef$getCur;
    _routeRef.current = _navigationRef == null ? void 0 : (_navigationRef$getCur = _navigationRef.getCurrentRoute()) == null ? void 0 : _navigationRef$getCur.name;
  };
  var _onStateChange = function _onStateChange(state) {
    var _state$routes, _state$routes2, _navigationRef$getCur2;
    var _prevRoute = _routeRef.current;
    var _currentRoute = (state == null ? void 0 : (_state$routes = state.routes) == null ? void 0 : (_state$routes2 = _state$routes[state.routes.length - 1]) == null ? void 0 : _state$routes2.name) || (_navigationRef == null ? void 0 : (_navigationRef$getCur2 = _navigationRef.getCurrentRoute()) == null ? void 0 : _navigationRef$getCur2.name);
    if (!isLoading && _currentRoute && _currentRoute !== _prevRoute) {
      _trackScreen(_currentRoute);
      _routeRef.current = _currentRoute;
    }
  };
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  return (0, _jsxRuntime.jsx)(_Context.OnboardingGroupContext.Provider, {
    value: Object.assign({
      isLoading: isLoading,
      person: person
    }, extraControllerProps),
    children: (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: {
        flex: 1
      },
      testID: "OnboardingGroup",
      children: (0, _jsxRuntime.jsx)(_native.NavigationContainer, {
        ref: _navigationRef,
        independent: true,
        documentTitle: {
          enabled: false
        },
        theme: Object.assign({}, _native.DefaultTheme, {
          colors: Object.assign({}, _native.DefaultTheme.colors, {
            primary: colors.brand,
            background: colors.background,
            card: colors.background,
            text: colors.text,
            border: colors.navBorder,
            notification: colors.brand
          })
        }),
        onReady: _onReady,
        onStateChange: _onStateChange,
        children: (0, _jsxRuntime.jsxs)(Stack.Navigator, {
          initialRouteName: OnboardingGroupPages.Start,
          screenOptions: {
            headerShown: false,
            animation: 'fade'
          },
          children: [(0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Start,
            component: Pages.Start
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.AboutYou,
            component: Pages.AboutYou
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Car,
            component: Pages.Car
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Flights,
            component: Pages.Flights
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Diet,
            component: Pages.Diet
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.House,
            component: Pages.House
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Goals,
            component: Pages.Goals
          }), (0, _jsxRuntime.jsx)(Stack.Screen, {
            name: OnboardingGroupPages.Summary,
            component: Pages.Summary
          }), (0, _jsxRuntime.jsxs)(Stack.Group, {
            children: [(0, _jsxRuntime.jsx)(Stack.Screen, {
              name: OnboardingGroupPages.Steps,
              component: Pages.Steps
            }), (0, _jsxRuntime.jsx)(Stack.Screen, {
              name: OnboardingGroupPages.StepsSuccess,
              component: Pages.StepsSuccess
            })]
          })]
        })
      })
    })
  });
});